export const APP_STORE_LINK = {
  android: 'https://play.google.com/store/apps/details?id=com.igogo',
  ios: 'https://apps.apple.com/us/app/id1524244020',
};
